import React from 'react';
import { numberWithCommas } from '../../../utils/helpers';

const InvestmentDashboardTable = ({ data }) => {
	return (
		<div className='table-responsive'>
			<table className='table table-sm myTable text-center caption-top'>
				<thead>
					<tr>
						<th>#</th>
						<th>Date</th>
						<th>Amount</th>
						<th>Percentage</th>
						<th>Current MaxCap</th>
						<th>Profit</th>
						<th>MaxCap After</th>
					</tr>
				</thead>
				<tbody>
					{data.map((card, key) => {
						const currentPercentage = Number(
							((card.before.usedMaxCap * 100) / card.maxCap).toFixed(2)
						);
						const afterPercentage = Number(
							((card.after.usedMaxCap * 100) / card.maxCap).toFixed(2)
						);
						return (
							<tr key={key}>
								<td>{Number(key) + 1}</td>
								<td>{new Date(card.date).toLocaleDateString()}</td>
								<td>{'$' + numberWithCommas(card.amount / 1e6)}</td>
								<td>{card.percentage}%</td>
								<td>
									<div>{`${currentPercentage}%`}</div>
									<div className='d-flex justify-content-center align-items-center'>
										<span
											className='progress myProgress'
											title={`${currentPercentage}%`}
											style={{
												width: '80px',
												height: '10px',
											}}>
											<div
												className='progress-bar'
												role='progressbar'
												aria-label='Max Cap'
												style={{
													width: `${currentPercentage}%`,
												}}
												aria-valuenow={Number(currentPercentage)}
												aria-valuemin='0'
												aria-valuemax='100'></div>
										</span>
									</div>
									<div className='fs-7 mt-1 text-set3'>
										{'$' +
											numberWithCommas(
												Math.round((card.before.usedMaxCap * 100) / 1e6) /
													100
											)}{' '}
										/{' '}
										{'$' +
											numberWithCommas(
												Math.round((card.maxCap * 100) / 1e6) / 100
											)}{' '}
									</div>
								</td>
								<td className='px-2'>
									{'$' +
										numberWithCommas(
											Math.round((card.expectedProfit * 100) / 1e6) / 100
										)}
								</td>
								<td>
									<div>{`${afterPercentage}%`}</div>
									<div className='d-flex justify-content-center align-items-center'>
										<span
											className='progress myProgress'
											title={`${afterPercentage}%`}
											style={{
												width: '80px',
												height: '10px',
											}}>
											<div
												className='progress-bar'
												role='progressbar'
												aria-label='Max Cap'
												style={{
													width: `${afterPercentage}%`,
												}}
												aria-valuenow={Number(afterPercentage)}
												aria-valuemin='0'
												aria-valuemax='100'></div>
										</span>
									</div>
									<div className='fs-7 mt-1 text-set3'>
										{'$' +
											numberWithCommas(
												Math.round((card.after.usedMaxCap * 100) / 1e6) /
													100
											)}{' '}
										/{' '}
										{'$' +
											numberWithCommas(
												Math.round((card.maxCap * 100) / 1e6) / 100
											)}{' '}
									</div>
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
};

export default InvestmentDashboardTable;
